import React, { useState } from 'react';
import Cropper from 'react-easy-crop';
import getCroppedImg from './cropImage';
import './styles.css';

const CropperProfilePicture = ({
  image,
  handleCroppedImage,
  handleCancelCrop,
  uploadLoading,
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const getCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(
        image,
        croppedAreaPixels,
        rotation
      );

      handleCroppedImage(croppedImage);
      setZoom(1);
      setRotation(0);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <div className="easy-crop-profile-picture__container">
        <Cropper
          image={image}
          crop={crop}
          rotation={rotation}
          zoom={zoom}
          aspect={1 / 1}
          onCropChange={setCrop}
          onRotationChange={setRotation}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        />
      </div>
      <div className="controls">
        <>
          <label>Zoom</label>
          <input
            type="range"
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            aria-labelledby="Zoom"
            onChange={(e) => {
              setZoom(e.target.value);
            }}
            className="zoom-range-profile-picture"
          />
        </>

        <>
          <label>Rotate</label>
          <input
            type="range"
            value={rotation}
            min={0}
            max={360}
            step={1}
            aria-labelledby="Rotation"
            onChange={(e) => setRotation(e.target.value)}
            className="rotation-range-profile-picture"
          />
        </>

        <div className="easy-crop-profile-picture__button-container">
          <button
            type="button"
            className="easy-crop-profile-picture__button cancel"
            onClick={handleCancelCrop}
          >
            Cancel
          </button>
          <button
            type="button"
            className="easy-crop-profile-picture__button save"
            onClick={getCroppedImage}
            disabled={uploadLoading}
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
};

export default CropperProfilePicture;
